module.exports = __webpack_public_path__ + "static/media/gs.7eefccbc.svg";